// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton_skeleton__xUXxh","shimmer":"Skeleton_shimmer__xlyru"};